import React, { Component } from "react";
// import axios from "axios";
import { PiCertificateThin } from "react-icons/pi";
import { FaAppStore } from "react-icons/fa";
import { AiOutlineDatabase } from "react-icons/ai";
import { CiPen } from "react-icons/ci";
import { GiBlackBook } from "react-icons/gi";
import { LuNotebook } from "react-icons/lu";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { GiField } from "react-icons/gi";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineVerified } from "react-icons/md";
import { FaRegSadTear } from "react-icons/fa";

class IncludeCourse extends Component {
    state = {
        course: [],
        buttoncontent: "View All"
    }
    getIconForOption = (option) => {
        switch (option) {
            case 'Software':
                return <FaAppStore />;
            case 'Data':
                return <AiOutlineDatabase />;
            case 'Biro':
                return <CiPen />;
            case 'Jotter':
                return <LuNotebook />;
            case 'Manual':
                return <GiBlackBook />;
            case '100% Practical':
                return <MdOutlineVerifiedUser />;
            case 'Field Experience':
                return <GiField />;
            case 'Free Consultation':
                return <MdOutlinePhoneInTalk />;
            case 'Exam and Certificate':
                return <PiCertificateThin />; // Use PiCertificateThin here
            case 'Free internship':
                return <MdOutlineVerified />;
            case 'Access job opportunities':
                return <MdOutlineVerified />;
            default:
                return null;
        }
    };


    componentDidMount() {
        this.setState({course: this.props.course})
    }
    componentDidUpdate(prevProps) {
        if (this.props.course !== prevProps.course) {
            this.setState({course: this.props.course})
            // this.fetchCourses();
        }
    }

    // fetchCourses = async () => {
    //     const accessToken = localStorage.getItem("accessToken");
    //     try {
    //         const course_id = this.props.course_id;
    //         const courseId = parseInt(course_id, 10);
    //         let headers = {}; // Initialize an empty headers object

    //         if (accessToken) {
    //             headers = {
    //                 Authorization: `Bearer ${accessToken}`,
    //             };
    //         }

    //         const response = await axios.get(`https://api.geoinfoacademy.com/api/courses/${courseId}`, {
    //             headers: headers,
    //         });

    //         const courseData = response.data;
    //         this.setState({ course: courseData });

    //         // Initialize checkedOptions based on API data
    //         if (courseData && courseData.package) {
    //             const initialChecked = new Set(courseData.package.map(item => item.value));
    //             this.setState({ checkedOptions: initialChecked });
    //         }

    //         console.log("API Response:", courseData);
    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //     }
    // };



    handlebutton = () => {
        if (this.state.buttoncontent === "View All") {
            this.setState({
                buttoncontent: "View Less"
            })
        } else {
            this.setState({
                buttoncontent: "View All"
            })
        }
    }


    render() {
        console.log("checking the include", this.state)
        const coursecontent = this.state.course;
        const include =
  coursecontent &&
  coursecontent.package &&
  coursecontent.package.length ? (
    coursecontent.package
      .filter((packageItem) => packageItem !== "Jotter") // ❌ remove jotter
      .map((packageItem) => {
        const packages =
          packageItem === "Biro" ? "jotting materials" : packageItem;

        return (
          <li className="body" key={packageItem}>
            {this.getIconForOption(packageItem)}
            <span>{packages}</span>
          </li>
        );
      })
        ) : (
            <div className="enroll_error" >
                <div className="enroll_cover">
                    <FaRegSadTear />
                    <p>The Course doesn't come with any thing</p>
                </div>
            </div>);

        const sectionStyle = {
            height: this.state.buttoncontent === "View Less" ? 'auto' : '250px',
        };

        return (
            <section className="descript_include" style={sectionStyle} >
                <li className="head">WHAT’S INCLUDED</li>
                {include}
                {this.state.course.package && this.state.course.package.length > 5 ? <button onClick={this.handlebutton}>{this.state.buttoncontent}</button> : null}
            </section>
        );
    }
}

export default IncludeCourse;
